import React, { useCallback, useMemo, useState } from 'react';

import { isMobile, resizeContent } from '../../../../../helpers';
import { useTranslation } from '../../../../../hooks';
import { CashbackGame } from '../../../../../models';
import { T } from '../../../../../constants';
import { RewardsGameTile } from '../game-tile';

import './style.scss';

interface EligibleGamesProps {
  games: Array<CashbackGame>;
  onBack: () => void;
  onClose: () => void;
  onGameRedirect: () => void;
}

export const EligibleGames: React.FC<EligibleGamesProps> = ({
  games,
  onBack,
  onClose,
  onGameRedirect
}) => {

  const t = useTranslation();

  const [searchValue, setSearchValue] = useState('');

  const filteredGames = useMemo(() => {
    return games.filter(game =>
      game.gameName?.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [games, searchValue]);

  const popupRefCallback = useCallback((element: HTMLDivElement) => {
    if (element && !isMobile()) {
      resizeContent({ target: element });
      window.addEventListener('resize', () => resizeContent({ target: element }));
    }
  }, []);

  return (
    <div className="eligible-games-wrapper open">
        <div className="eligible-games-container" ref={popupRefCallback}>
            <div className="eligible-games-widget">
                <div className="eligible-games-widget-header">
                    <div className="eligible-games-widget-back" onClick={onBack}>
                        <span className="icon-arrow-left back-eligible"></span>
                    </div>
                    <p className="mission-details-text">{t(T.ALL_ELIGIBLE_GAMES)}</p>
                    <button className="close-btn-mission-details" type="button" onClick={onClose}>
                        <span className="icon-close mission-details-cloe-icon" />
                    </button>
                </div>
                <div className="eligible-games-widget-body">
                    <div className="eligible-games-widget-body-scroll">
                        <div className="eligible-games-search-block">
                            <input
                              type="text"
                              className="eligible-games-search"
                              placeholder={t(T.SEARCH)}
                              value={searchValue}
                              onChange={(event) => setSearchValue(event.target.value)}
                            />
                            <span className="icon-search search-games-icon"></span>
                        </div>
                        <div className="eligible-games-wrapper-content">
                            <div className="suggested-block-content">
                                <div className="suggested-block-content-inner">
                                    {filteredGames.length === 0 && <div>{t(T.NO_DATA_TO_DISPLAY)}</div>}
                                    {
                                      filteredGames.map((game) => (
                                        <RewardsGameTile
                                          key={game.gameId}
                                          game={game}
                                          onRedirect={onGameRedirect}
                                        />
                                      ))
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
};
